window.globalHelpersModule.directive "canceled", 
['$rootScope', '$log', '$timeout', '$filter', '$state', 'AuthService'
($rootScope, $log, $timeout, $filter, $state, AuthService) ->
  restrict: "E"
  scope:
    feedItem: "="
  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/feed-items/canceled/canceled-directive-template.html'
]